import { get } from 'lodash';
import React, { useState, useEffect } from 'react';
import EditarTipoPerfil from './EditarTipoPerfil';
import { dialogoConfirmacion } from '../../../../utils/Common';
import VainillaDialog from '../../../sharecomponents/vanilladialog';

const AdministradorPerfilesSubseccion = (p) => {
    const [perfiles, setperfiles] = useState([]);
    const keyGen = p.keyGen ?? (() => { });
    const getAPI = p.getAPI ?? (async () => { });
    const getData = p.getData ?? (async () => { });
    const [nuevo, setnuevo] = useState('');
    const [edicion, setedicion] = useState(null);
    const [dialog, setdialog] = useState({ show: false });


    useEffect(() => {
        setperfiles(p.perfiles);
    }, [p.perfiles]);

    const agregartipo = async () => {
        let resp = await getAPI("/secure/users/types/add", { name: nuevo });
        if (resp) {
            getData();
            setnuevo('');
        }
    }

    const confirmarEliminar = (perfil) => dialogoConfirmacion(setdialog, `¿Está seguro de eliminar el perfil ${perfil.nombre}? esta acción no es reversible`, () => eliminar(perfil.id));

    const eliminar = async (id) => {
        let resp = await getAPI("/secure/users/types/delete", { id: id });
        if (!resp) return;
        getData();
    }

    return (
        <>
            <VainillaDialog data={dialog} />
            {edicion && <EditarTipoPerfil data={edicion} close={(update) => {
                if (update) getData(); setedicion(null);
            }} />}
            <div className='bw-1200 round-s border p-2 pt-0 bg-white blur-xl mt-2 mb-3 overflow relative' style={{ height: "50vh", transition: "height 0.5s" }}>

                <div className='w-100 sticky bg-white4 blur-l pb-2 pt-2' style={{ top: 0, left: 0, zIndex: 2 }}>
                    <div className='row justify-content-end w-100 m-0 p-0'>
                        <div className='bw-300 mt-2'>
                            <div className='w-100 m-0 p-0 text-xs text-bold text-center'>Nuevo nombre de perfil de usuario</div>
                            <input type='text' className='form-control form-control-sm border shadow-sm round-xxl shadow-sm' onChange={(e) => setnuevo(e.target.value)} />
                        </div>
                        <div className='bw-200 mt-2'>
                            <div className='w-100 text-center ps-2 text-xs text-bold'>{nuevo === '' ? "Agregue primero el nombre" : 'Pulse para agregar'}</div>
                            <button className='btn btn-sm round-xxl border border-warning text-bold w-100 btn-light shadow' disabled={nuevo === ''} onClick={agregartipo} >Nuevo perfil</button>
                        </div>
                    </div>
                </div>

                {perfiles.map((perfil, i) => <div className={`w-100 p-1 round-s mb-3 border bg-light `} key={keyGen()}>
                    <span className='text-xs me-2'>perfil:</span>
                    <span className='text-bold'>{perfil.nombre}</span>
                    <div className='bw-800 border border-bottom border-info'></div>
                    <div className='row justify-content-evenly w-100 m-0 p-0'>
                        <div className='bw-300 mb-2'>
                            <div className='w-100 m-0 p-0 text-xs text-bold'>Usuarios con este perfil</div>
                            <div className='w-100 border-bottom border-drk'>{perfil.total}</div>
                        </div>
                        <div className='bw-200 mb-2'>
                            <div className='w-100 m-0 p-0 text-xs text-bold'>{perfil.total > 0 ? 'No eliminable, hay usuarios asociados' : 'Disponible para eliminar'} </div>
                            <button className='btn pt-0 pb-0 btn-sm w-100 btn-light border border-danger shadow'
                                onClick={() => confirmarEliminar(perfil)}
                                disabled={perfil.total > 0}
                            >Eliminar este perfil</button>
                        </div>
                        <div className='bw-200 mb-2'>
                            <div className='w-100 m-0 p-0 text-xs text-bold'>Editar perfil</div>
                            <button className='btn btn-sm w-100 btn-light border border-warning border-2 text-bold shadow' onClick={() => setedicion(perfil)} >Abrir editor</button>
                        </div>
                        {/*<div className='bw-300 mb-2'>
                            <div className='w-100 m-0 p-0 text-xs text-bold'>Tipo de perfil</div>
                            <div className='w-100 border-bottom border-drk'>{usuario.perfil_nombre}</div>
                        </div>
                        <div className='bw-200 mb-2'>
                            <div className='w-100 m-0 p-0 text-xs text-bold'>Cambiar tipo de perfil</div>
                            <select className='form-control form-control-sm border shadow-sm' defaultValue={usuario.perfil}
                                disabled={usuario.estatus == 0}
                                onChange={(e) => { cambiarTipo(usuario.id, e.target.value) }}>
                                {data.perfiles.map((perfil, i) => <option value={perfil.id} key={keyGen()} >{perfil.nombre}</option>)}
                            </select>
                        </div>
                        <div className='bw-200 mb-2'>
                            <div className='w-100 m-0 p-0 text-xs text-bold'>Ajustar nombre y contraseña</div>
                            <button className='btn btn-sm w-100 btn-light border border-warning shadow' onClick={() => seteditUser(usuario)} >Pulse para editar</button>
                        </div>*/}
                    </div>
                </div>)}
            </div>
        </>
    )
}

export default AdministradorPerfilesSubseccion;